import { combineReducers } from 'redux';

import classroomLesson from './classroomLesson';
import classroomLessons from './classroomLessons'; // this is the admin one
import classroomLessonsReviews from './classroomLessonsReviews';
import classroomSessions from './classroomSessions';
import customize, * as FromCustomize from './customize';

const combinedReducers = combineReducers({
  classroomLesson,
  classroomLessons,
  classroomLessonsReviews,
  classroomSessions,
  customize,
});

export default combinedReducers;

export function getIncompleteQuestions(store) {
  return FromCustomize.getIncompleteQuestions(store.customize);
}

export function getStoredEditionMetadata(store, props) {
  const editionId = props.match.params.editionID;
  const editions = FromCustomize.getEditionMetadata(store.customize);

  return editions[editionId];
}

export function getStoredEditionQuestions(store) {
  return FromCustomize.getEditionQuestions(store.customize);
}

export function getStoredOriginalEditionQuestions(store) {
  return FromCustomize.getOriginalEditionQuestions(store.customize);
}
